module.exports = new __parcel__URL__("pve_opponent_pfp.43c4e9ee.png").toString();